import { Injectable } from '@angular/core';
import { createWarning } from '@core/helpers/create-validator.helper';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { toNum } from '@shared/helpers/math.helper';

@Injectable()
export class DatiBilancioBisWarningsService {
    constructor(private readonly store: Store<Revisione53State>) {}

    my_NumBilanciInExcelSezI = createWarning(this.store, (myVerbale) => {
        const my_NumBilanciInExcel = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_NumBilanciInExcel;

        if (my_NumBilanciInExcel === '1') {
            return 'Si ricorda al revisore che è possibile inserire un solo bilancio nel file. Per fare ciò è sufficiente non indicare nulla nella colonna D (Primo bilancio). In particolare si raccomanda di non inserire la data di approvazione, il tipo di schema ed il tipo di bilancio in suddetta colonna, così come non dovranno essere indicati valori nello stato patrimoniale e nel conto economico.';
        }
    });

    my_BilancioAllegato = createWarning(this.store, (myVerbale) => {
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (isNilOrEmpty(my_BilancioAllegato)) {
            return 'Allegare un bilancio';
        }
    });

    my_ChiusuraEsercizio = createWarning(this.store, (myVerbale) => {
        const my_ChiusuraEsercizio = myVerbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_ChiusuraEsercizio;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(!isNilOrEmpty(my_ChiusuraEsercizio) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Specificare gg-mm di chiusura esercizio';
        }
    });

    my_BilAnno1 = createWarning(this.store, (myVerbale) => {
        const my_BilAnno1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_BilAnno1;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(!isNilOrEmpty(my_BilAnno1) || isNilOrEmpty(my_BilancioAllegato))) {
            return "Specificare l'anno del 1° bilancio";
        }
    });

    my_BilAnno2II = createWarning(this.store, (myVerbale) => {
        const my_BilAnno2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_BilAnno2;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(!isNilOrEmpty(my_BilAnno2) || isNilOrEmpty(my_BilancioAllegato))) {
            return "Specificare l'anno del 2° bilancio";
        }
    });

    my_DataApprovazione1 = createWarning(this.store, (myVerbale) => {
        const my_DataApprovazione1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione1;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_TipoSchemaBil1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoSchemaBil1;

        if (!(isNilOrEmpty(my_BilancioAllegato) || !isNilOrEmpty(my_DataApprovazione1) || isNilOrEmpty(my_TipoSchemaBil1))) {
            return 'Specificare la data di approvazione del 1° bilancio';
        }
    });

    my_DataApprovazione1II = createWarning(this.store, (myVerbale) => {
        const my_DataApprovazione1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione1;
        const my_TipoSchemaBil1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoSchemaBil1;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(!isNilOrEmpty(my_DataApprovazione1) || isNilOrEmpty(my_TipoSchemaBil1) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Il bilancio del 1° anno non è stato inserito';
        }
    });

    my_TipoSchemaBil2 = createWarning(this.store, (myVerbale) => {
        const my_DataApprovazione2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione2;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_TipoSchemaBil2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoSchemaBil2;

        if (isNilOrEmpty(my_DataApprovazione2) && !(isNilOrEmpty(my_BilancioAllegato) && !isNilOrEmpty(my_TipoSchemaBil2))) {
            return 'Specificare la data di approvazione del 2° bilancio';
        }
    });

    my_TipoBilancioAbbr1 = createWarning(this.store, (myVerbale) => {
        const my_TipoSchemaBil1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoSchemaBil1;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_DataApprovazione1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione1;

        if (!(!isNilOrEmpty(my_TipoSchemaBil1) || isNilOrEmpty(my_DataApprovazione1) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Specificare il tipo schema del 1° bilancio';
        }
    });

    my_TipoBilancioAbbr2 = createWarning(this.store, (myVerbale) => {
        const my_TipoSchemaBil2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoSchemaBil2;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(!isNilOrEmpty(my_TipoSchemaBil2) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Specificare il tipo schema del 2° bilancio';
        }
    });

    my_TipoBilancioAbbr1II = createWarning(this.store, (myVerbale) => {
        const my_TipoBilancioAbbr1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoBilancioAbbr1;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_DataApprovazione1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione1;

        if (!(!isNilOrEmpty(my_TipoBilancioAbbr1) || isNilOrEmpty(my_DataApprovazione1) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Specificare il tipo del 1° bilancio';
        }
    });

    my_TipoBilancioAbbr2II = createWarning(this.store, (myVerbale) => {
        const my_TipoBilancioAbbr2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoBilancioAbbr2;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(!isNilOrEmpty(my_TipoBilancioAbbr2) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Specificare il tipo del 2° bilancio';
        }
    });

    my_StPaPsTOT1 = createWarning(this.store, (myVerbale) => {
        const my_StPaPsTOT1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsTOT1;
        const my_StPaAtTOT1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Attivo.my_StPaAtTOT1;

        if (my_StPaPsTOT1 != my_StPaAtTOT1) {
            return 'Nel Bilancio del primo anno, il Totale Attivo deve essere uguale al Totale Passivo!';
        }
    });

    my_StPaPsTOT2 = createWarning(this.store, (myVerbale) => {
        const my_StPaPsTOT2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsTOT2;
        const my_StPaAtTOT2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Attivo.my_StPaAtTOT2;

        if (my_StPaPsTOT2 != my_StPaAtTOT2) {
            return 'Nel Bilancio del secondo anno, il Totale Attivo deve essere uguale al Totale Passivo!';
        }
    });

    my_CoEcA12 = createWarning(this.store, (myVerbale) => {
        const my_CoEcA12 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_ContoEconomico.my_CoEcA12;

        if (!isNilOrEmpty(my_CoEcA12) && toNum(my_CoEcA12) >= 22523684.69) {
            return 'La cooperativa ha un fatturato superiore a euro 22.523.684,69. Pertanto è revisionabile annualmente';
        }
    });
}
